/** Canonical Leads routes. Import these instead of string literals. */
export const LEADS_ROUTES = Object.freeze({
  LIST: '/leads',
  /** Auto-assign settings: team switch, who takes leads, per-person limits. */
  ASSIGNMENT: '/leads/assignment',
  // React Router ranks static siblings above `:userId`, so later static pages
  // (e.g. /leads/erase) can be added without reordering.
  DETAIL: '/leads/:userId',
});

/**
 * Lead detail path.
 * @param {string} userId - The lead's UserProfile id.
 * @returns {string}
 */
export function leadDetailPath(userId) {
  return `/leads/${encodeURIComponent(String(userId || ''))}`;
}

/**
 * App profile of a registered user (the coach Users dashboard).
 * @param {string} userId
 * @returns {string}
 */
export function appProfilePath(userId) {
  return `/dashboard/${encodeURIComponent(String(userId || ''))}`;
}
